// extracted by mini-css-extract-plugin
export var fileUpload = "_ef-1";
export var modalButton = "_ef-0";